/**
 * @copyright 2026 Fortee Uniforme Inc. All rights reserved.
 * @license PROPRIETARY - Unauthorized copying prohibited.
 * Protected under the Canadian Copyright Act (R.S.C., 1985, c. C-42).
 */

// fortee-zone-debug.js - TEMPORARY diagnostic instrumentation.
//
// Added for quick task 260802-ffl to answer, on the live page rather than by
// reading code, which source a print area's zone config and physical dimensions
// actually came from. It exists because the failure it diagnoses is SILENT: a
// zone with no wIn falls back to the shared print_areas metaobject's catalogue
// width and aspect, and nothing on screen says so.
//
// HOW TO REMOVE (three steps, all safe to do at any time):
//   1. Delete this file.
//   2. Delete the two `{{ 'fortee-zone-debug.js' | asset_url | script_tag }}`
//      lines in sections/main-single-builder.liquid and
//      sections/main-bundle-builder-2step.liquid.
//   3. Delete the `window.forteeZoneDebug && window.forteeZoneDebug(...)` call
//      sites in assets/single-builder.js and assets/bundle-builder-2step.js.
// Steps 1 and 2 alone are enough to make it inert: every call site is guarded,
// so an orphaned call with this file absent is a no-op and cannot throw. Leaving
// the calls behind briefly is safe; leaving them behind forever is clutter.
//
// THE GATE. Without `?ftbzonedebug=1` in the query string this file defines
// nothing and prints nothing, so a customer's console stays empty and the cost
// is one string search at parse time. The gate is checked ONCE here rather than
// per call, so a normal page load pays for it exactly once.

(function () {
  'use strict';

  var FLAG = 'ftbzonedebug=1';

  var search = '';
  try {
    search = (window.location && window.location.search) || '';
  } catch (e) {
    search = '';
  }

  if (search.indexOf(FLAG) === -1) {
    // Explicitly undefined rather than a silent no-op function: the guarded call
    // form `window.forteeZoneDebug && window.forteeZoneDebug(...)` then costs a
    // single property read, and nothing serialises a payload that is discarded.
    window.forteeZoneDebug = undefined;
    return;
  }

  window.forteeZoneDebug = function (label, payload) {
    if (!window.console) return;
    var group = console.groupCollapsed || console.log;
    try {
      group.call(console, '[ftb-zone] ' + String(label));
      if (console.table) console.table(payload);
      else console.log(payload);
    } catch (e) {
      try { console.log('[ftb-zone] ' + String(label), payload); } catch (e2) { /* never break the page for a log */ }
    }
    if (console.groupEnd) {
      try { console.groupEnd(); } catch (e3) { /* ignore */ }
    }
  };

  if (window.console && console.log) {
    console.log('[ftb-zone] zone debug ACTIVE (?' + FLAG + '). Remove the query param to silence.');
  }
})();
